module.exports = __webpack_public_path__ + "img/user_male.1897f975.png";